import OrderAddressFields, {
  createValidationRules as vf,
} from './order-address-fields'

export const createValidationRules = vf
export default OrderAddressFields
